import constants from '../../constants.js';

const pad = num => (num < 10 ? "0" : "") + num;

export default function DataHandler(data) {
    return data.map(item => {
        let date = new Date(item.bookingResponse.DateBooking);
        let [d, m, y] = [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()];
        let [h, min] = [pad(date.getHours()), pad(date.getMinutes())];

        return {
            status: constants().STATUS[item.status],
            locator: item.bookingResponse.RecordLocator,
            sellTime: `${d}/${m}/${y} ${h}:${min}`,
            destiny: item.bookingResponse.Segments[0].DepartureStation + '/' + item.bookingResponse.Segments[0].ArrivalStation,
            email: item.email,
            phone: `(${item.areaCodePhone}) ${item.phoneNumber} (${item.areaCodeCellPhone}) ${item.cellPhoneNumber}`,
            name: item.cardOwnerName,
            sourceCode: item.bookingResponse.SourceCode,
            totalFare: (item.bookingResponse.TotalFare.TotalFare).toFixed(2),
            totalFee: (item.bookingResponse.TotalFare.TotalFee).toFixed(2),
            tax: (item.bookingResponse.TotalFare.TotalAdditionalFee + item.bookingResponse.TotalFare.TotalTaxes).toFixed(2),
            total: (item.bookingResponse.TotalFare.Total).toFixed(2),
            address: `${item.state} - ${item.city} - ${item.street}, ${item.neighborhood}, ${item.number}`,
            findUs: `${item.findUs}`,
        }
    });
}



// WEBPACK FOOTER //
// ./src/views/Users/DataHandler.js